import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main-content">
          {/* Left Section - Logo and Social Media */}
          <div className="footer-left-section">
            <div className="footer-logo-container">
              <img 
                src={`${process.env.PUBLIC_URL}/images/logo.jpeg`}
                alt="Pragati Vidyalaya Logo"
                className="footer-logo"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <div className="footer-logo-line"></div>
              <p className="footer-sanskrit-text">विद्या विन्दते बलम्</p>
            </div>
            <div className="footer-social-icons">
              <a
                href="https://www.facebook.com/profile.php?id=100073559916437"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Facebook"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/pragatividyalayachallakere/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@pragathividyalayachallaker7353"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="YouTube"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Middle-Left Section - Contact Info */}
          <div className="footer-contact-section">
            <h3 className="footer-title">PRAGATI VIDYALAYA</h3>
            <div className="footer-contact-info">
              <p className="contact-item">
                <span className="contact-icon">📍</span>
                Pragati Vidyalaya Nagaramgere Road Challakere 577522
              </p>
              <p className="contact-item">
                <span className="contact-icon">📞</span>
                +91 8660573737, +91 7996622466
              </p>
              <p className="contact-item">
                <span className="contact-icon">✉️</span>
                Email: <a href="mailto:pragnalkidz@gmail.com">pragnalkidz@gmail.com</a>
              </p>
            </div>
          </div>

          {/* Middle-Right Section - Navigation Links */}
          <div className="footer-nav-section">
            <div className="footer-nav-column">
              <Link to="/" className="footer-nav-link">HOME</Link>
              <Link to="/about" className="footer-nav-link">ABOUT US</Link>
              <Link to="/preschool" className="footer-nav-link">PRE-SCHOOL</Link>
            </div>
            <div className="footer-nav-separator"></div>
            <div className="footer-nav-column">
              <Link to="/offerings" className="footer-nav-link">OFFERINGS</Link>
              <Link to="/facility" className="footer-nav-link">FACILITY</Link>
              <Link to="/gallery" className="footer-nav-link">GALLERY</Link>
            </div>
          </div>
        </div>

        {/* Footer Separator Line */}
        <div className="footer-separator"></div>

        {/* Bottom Copyright Section */}
        <div className="footer-bottom">
          <p>
            © Copyright © 2025 Pragati Vidyalaya | Designed and developed by MITRA SOFTWARES
          </p>
        </div>
      </div>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button className="scroll-to-top" onClick={scrollToTop} aria-label="Scroll to top">
          <svg viewBox="0 0 24 24" fill="white" style={{transform: 'rotate(180deg)'}}>
            <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
          </svg>
        </button>
      )}
    </footer>
  );
};

export default Footer;

